/* KrakenTheMeta free tools — the decklist panel every tool shares: the paste box, "try an example",
 * clear, the status line, Ctrl/Cmd+Enter to run, and hand-offs between pages through localStorage
 * (a deck page or another tool stashes a list under the tool's key; the tool picks it up on load).
 */
import "../lib/ui.js";
import "./core.js";

(function () {
  "use strict";

  var KD = window.KD, esc = KD.esc;

  // opts: { key (localStorage hand-off key), example (text), run(text, reason), minLines }
  KD.toolPanel = function (opts) {
    var ta = KD.$("[data-deck]"), runBtn = KD.$("[data-run]"), status = KD.$("[data-status]"), ex = KD.$("[data-example]"), clr = KD.$("[data-clear]");
    var busy = false, label = runBtn ? runBtn.innerHTML : "";
    var api = {
      text: function () { return ta ? ta.value : ""; },
      set: function (t) { if (ta) { ta.value = t; ta.dispatchEvent(new Event("input")); } },
      status: function (msg, working) {
        if (status) { status.textContent = msg || ""; status.hidden = !msg; status.classList.toggle("is-working", !!working); }
        busy = !!working;
        if (runBtn) { runBtn.classList.toggle("is-busy", busy); runBtn.innerHTML = busy ? '<span class="spin" aria-hidden="true"></span><span>Working…</span>' : label; }
      },
      busy: function () { return busy; },
      // hand the current list to another page (e.g. the odds tool) and go there
      handoff: function (key, path, extra) {
        try { localStorage.setItem(key, api.text()); if (extra) Object.keys(extra).forEach(function (k) { localStorage.setItem(k, extra[k]); }); } catch (e) { /* the next page just opens empty */ }
        location.href = path;
      },
      stashForSignIn: function (returnPath, extra) {
        try {
          localStorage.setItem(opts.key, api.text());
          localStorage.setItem("kraken_return_to", returnPath);
          if (extra) Object.keys(extra).forEach(function (k) { localStorage.setItem(k, extra[k]); });
        } catch (e) { /* they'll paste again */ }
      }
    };
    function go(reason) {
      if (busy) return;
      var t = api.text();
      if (!t.trim()) { api.status("Paste a decklist first: one card per line, like “1 Sol Ring”."); if (ta) ta.focus(); return; }
      opts.run(t, reason || "button");
    }
    if (runBtn) runBtn.addEventListener("click", function () { go("button"); });
    if (ta) ta.addEventListener("keydown", function (e) { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) { e.preventDefault(); go("keyboard"); } });
    if (ex) ex.addEventListener("click", function () { api.set(opts.example); go("example"); });
    if (clr) clr.addEventListener("click", function () { api.set(""); api.status(""); if (opts.clear) opts.clear(); if (ta) ta.focus(); });

    // a list handed over from another page runs straight away
    var pending = null;
    try { pending = localStorage.getItem(opts.key); if (pending) localStorage.removeItem(opts.key); } catch (e) { pending = null; }
    if (pending && pending.trim()) { api.set(pending.slice(0, 20000)); setTimeout(function () { go("handoff"); }, 0); }
    return api;
  };

  // "3 lines couldn't be matched" (they're shown, never silently dropped)
  KD.unmatchedHTML = function (rows, verb) {
    if (!rows || !rows.length) return "";
    return '<details class="tunmatched"><summary>' + rows.length + (rows.length === 1 ? " line" : " lines") + " didn't match a card (not " + (verb || "counted") + ")</summary><ul>" +
      rows.map(function (r) { return "<li>" + (r.quantity > 1 ? r.quantity + "× " : "") + esc(r.name) + "</li>"; }).join("") + "</ul></details>";
  };

  // a complete, real 100-card example (every name checked on Scryfall, all in Atraxa's colors)
  KD.EXAMPLE_CMD = ["Commander", "1 Atraxa, Praetors' Voice", "", "Deck"].concat([
    "Sol Ring", "Arcane Signet", "Fellwar Stone", "Talisman of Dominance", "Talisman of Progress", "Birds of Paradise", "Cultivate", "Farseek", "Rampant Growth", "Kodama's Reach", "Nature's Lore", "Solemn Simulacrum",
    "Rhystic Study", "Phyrexian Arena", "Sylvan Library", "Night's Whisper", "Read the Bones", "Skullclamp", "Mystic Remora", "Guardian Project", "Tatyova, Benthic Druid",
    "Swords to Plowshares", "Path to Exile", "Beast Within", "Counterspell", "Swan Song", "Anguished Unmaking", "Assassin's Trophy", "Generous Gift", "Mortify", "Putrefy",
    "Wrath of God", "Damnation", "Toxic Deluge", "Cyclonic Rift",
    "Doubling Season", "Anointed Procession", "Deepglow Skate", "Evolution Sage", "Flux Channeler", "Tezzeret's Gambit", "Inexorable Tide", "Contentious Plan", "Vorinclex, Monstrous Raider",
    "Corpsejack Menace", "Hardened Scales", "Winding Constrictor", "Walking Ballista", "Hangarback Walker", "Grateful Apparition", "Thrummingbird", "Ezuri, Claw of Progress", "Viral Drake",
    "Pestilent Syphoner", "Merfolk Skydiver", "Ajani, Mentor of Heroes", "Tamiyo, Field Researcher", "Kiora's Follower", "Bloom Tender", "Master Biomancer", "Nissa, Resurgent Animist",
    "Heroic Intervention", "Eternal Witness",
    "Command Tower", "Exotic Orchard", "Path of Ancestry", "Temple Garden", "Breeding Pool", "Overgrown Tomb", "Hallowed Fountain", "Watery Grave", "Godless Shrine", "Karn's Bastion",
    "Opulent Palace", "Arcane Sanctum", "Sandsteppe Citadel", "Llanowar Wastes", "Adarkar Wastes"
  ].map(function (n) { return "1 " + n; })).concat(["6 Forest", "5 Island", "5 Swamp", "5 Plains"]).join("\n");
})();
